/**
 * Filter builder constants — operators, helper factories.
 */

export const OPERATORS = {
  string: [
    { value: 'eq', label: 'Equals' }, { value: 'neq', label: 'Not Equals' },
    { value: 'contains', label: 'Contains' }, { value: 'not_contains', label: 'Not Contain' },
    { value: 'starts_with', label: 'Starts With' }, { value: 'ends_with', label: 'Ends With' },
    { value: 'in', label: 'In List' },
    { value: 'is_empty', label: 'Is Empty' }, { value: 'is_not_empty', label: 'Not Empty' },
  ],
  number: [
    { value: 'eq', label: '=' }, { value: 'neq', label: '!=' },
    { value: 'gt', label: '>' }, { value: 'gte', label: '>=' },
    { value: 'lt', label: '<' }, { value: 'lte', label: '<=' },
    { value: 'between', label: 'Between' },
    { value: 'is_empty', label: 'Is Empty' }, { value: 'is_not_empty', label: 'Not Empty' },
  ],
  date: [
    { value: 'eq', label: 'Equals' }, { value: 'gt', label: 'After' }, { value: 'lt', label: 'Before' },
    { value: 'gte', label: 'On/After' }, { value: 'lte', label: 'On/Before' }, { value: 'between', label: 'Between' },
    { value: 'is_empty', label: 'Is Empty' }, { value: 'is_not_empty', label: 'Not Empty' },
  ],
  datetime: [
    { value: 'gt', label: 'After' }, { value: 'lt', label: 'Before' },
    { value: 'gte', label: 'On/After' }, { value: 'lte', label: 'On/Before' }, { value: 'between', label: 'Between' },
    { value: 'is_empty', label: 'Is Empty' }, { value: 'is_not_empty', label: 'Not Empty' },
  ],
  enum: [
    { value: 'eq', label: 'Equals' }, { value: 'neq', label: 'Not Equals' },
    { value: 'in', label: 'In List' }, { value: 'not_in', label: 'Not In' },
    { value: 'is_empty', label: 'Is Empty' }, { value: 'is_not_empty', label: 'Not Empty' },
  ],
  boolean: [{ value: 'eq', label: 'Equals' }],
};

export const NO_VALUE_OPS = new Set(['is_empty', 'is_not_empty']);

let _uid = 0;
export function uid() { return 'f' + (++_uid) + '_' + Date.now().toString(36); }
export function mkCond() { return { id: uid(), field: '', operator: 'contains', value: '' }; }
export function mkGroup(logic) { return { id: uid(), logic: logic || 'OR', conditions: [mkCond()] }; }
